import { Duo } from '.';
import { Pet } from '../buruburu/pet';
import { getDynamicReceiverBucket } from '../getters/ab';
import ab from '../ruleset/ab';
import features from '../ruleset/features';
import { weightedRandom } from '../utils/random';

export const hasMetUnlockCriteria = (state: Duo.State) =>
  Pet.getters(state).getCurrentEvolution().stage === 'adult';

export function isUnlocked(state: Duo.State) {
  if (!features(state).duo) {
    return false;
  }

  return hasMetUnlockCriteria(state);
}

export function canRequestDuo(state: Duo.State) {
  if (!features(state).duo) {
    return false;
  }

  const { visitSession } = state.visit;
  if (!visitSession) {
    return false;
  }

  const { friendId, currentEvolution } = visitSession;
  return false;
  /*
  if (getDynamicReceiverBucket(ab.tests.TEST_DUO, friendId) !== 'enabled') {
    return false;
  }

  const { Pet } = Duo.$DEPENDENCIES;
  return (
    Pet.getters(state).getCurrentEvolution().stage === 'adult' &&
    currentEvolution.stage === 'adult'
  );*/
}

export function hasPendingSentInvitations(state: Duo.State, now: number) {
  const { visitSession } = state.visit;
  if (!visitSession) {
    return false;
  }

  return getNonExpiredSentInvitations(state, now).some(
    ({ playerId, status }) =>
      visitSession.friendId === playerId && status === 'pending',
  );
}

export function hasPendingReceivedInvitations(state: Duo.State, now: number) {
  const { visitSession } = state.visit;
  if (!visitSession) {
    return false;
  }

  return getNonExpiredReceivedInvitations(state, now).some(
    ({ playerId, status }) =>
      visitSession.friendId === playerId && status === 'pending',
  );
}

export function getNonExpiredSentInvitations(state: Duo.State, now: number) {
  const { sent } = state.duo.invitations;

  return sent.filter(
    ({ timestamp }) => !Duo.api.isExpiredInvitation(timestamp, now),
  );
}

export function getNonExpiredReceivedInvitations(
  state: Duo.State,
  now: number,
) {
  const {
    duo: {
      invitations: { received },
    },
  } = state;

  return received.filter(
    ({ timestamp }) => !Duo.api.isExpiredInvitation(timestamp, now),
  );
}

export function getNewSpecies(
  weights: Record<string, number>[],
  random: () => number,
) {
  // Sum up all weights.
  const combinedWeights = weights.reduce((acc, cur) => {
    Object.keys(cur).forEach((key) => {
      acc[key] = (acc[key] || 0) + cur[key];
    });
    return acc;
  }, {});

  // Randomly pick a species.
  const roll = weightedRandom(Object.values(combinedWeights), random);
  return Object.keys(combinedWeights)[roll];
}
